"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconSmile = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconSmile = function SvgIconSmile(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76 1.238a5.476 5.476 0 012.002 2.001A5.38 5.38 0 0111.5 6c0 .998-.246 1.918-.738 2.76a5.476 5.476 0 01-2.001 2.002A5.381 5.381 0 016 11.5a5.381 5.381 0 01-2.762-.738 5.477 5.477 0 01-2.001-2.001A5.381 5.381 0 01.5 6c0-.998.246-1.918.738-2.76a5.476 5.476 0 012.001-2.002A5.38 5.38 0 016 .5a5.38 5.38 0 012.76.738zm.48 8.003c.409-.409.735-.896.978-1.461A4.451 4.451 0 0010.584 6c0-.62-.122-1.214-.366-1.78a4.629 4.629 0 00-.977-1.46 4.63 4.63 0 00-1.461-.978A4.455 4.455 0 006 1.417c-.62 0-1.214.121-1.78.365a4.632 4.632 0 00-1.46.977 4.63 4.63 0 00-.978 1.461A4.455 4.455 0 001.417 6c0 .62.122 1.214.365 1.78.244.565.57 1.052.978 1.46a4.63 4.63 0 001.46.978 4.457 4.457 0 001.78.365c.62 0 1.214-.121 1.78-.365a4.628 4.628 0 001.46-.977zM7.978 6.738a.45.45 0 01.35-.029c.12.038.208.113.266.226a.44.44 0 01.028.347 2.646 2.646 0 01-.988 1.396A2.694 2.694 0 016 9.208c-.606 0-1.15-.176-1.633-.53a2.644 2.644 0 01-.988-1.396.44.44 0 01.029-.347.437.437 0 01.272-.226.44.44 0 01.347.029.436.436 0 01.226.272c.119.382.34.691.662.927A1.79 1.79 0 006 8.292a1.79 1.79 0 001.085-.355 1.78 1.78 0 00.663-.927.433.433 0 01.229-.272zm-3.81-1.654c.253 0 .469-.09.648-.269a.883.883 0 00.268-.648.883.883 0 00-.268-.648.883.883 0 00-.648-.269c-.253 0-.47.09-.648.27a.883.883 0 00-.269.647c0 .253.09.47.269.648.179.18.395.269.648.269zm3.018-1.565a.884.884 0 01.649-.269c.252 0 .469.09.648.269.179.179.268.395.268.648s-.09.469-.268.648a.884.884 0 01-.648.268.884.884 0 01-.649-.268.884.884 0 01-.268-.648c0-.253.09-.47.268-.648z",
    fill: "currentColor"
  }));
};

exports.SvgIconSmile = SvgIconSmile;